<template>
  <Transition name="buy-service-tips">
    <div
      v-if="buyServiceTips"
      class="buy-service-tips"
      role="button"
      tabindex="0"
      aria-live="polite"
      @click="handleClick"
      @keydown.enter.prevent="handleClick"
      @keydown.space.prevent="handleClick"
    >
      <span class="message">{{ buyServiceTips.message }}</span>
      <button class="close" type="button" aria-label="關閉提示" @click.stop="handleClose">
        <img :src="CloseIcon" alt="" />
      </button>
    </div>
  </Transition>
</template>

<script setup>
import CloseIcon from '@/assets/images/icon/buy-service-tips-close.svg?url';
import { buyServiceTips, hideBuyServiceTips } from './state';

const handleClose = () => {
  hideBuyServiceTips(buyServiceTips.value?.id);
};

const handleClick = () => {
  const tip = buyServiceTips.value;
  if (!tip) return;

  hideBuyServiceTips(tip.id);
  tip.onClick?.();
};
</script>

<style lang="scss" scoped>
.buy-service-tips {
  position: fixed;
  z-index: 10000;
  top: 90px;
  left: 50%;
  box-sizing: border-box;
  max-width: calc(100vw - 48px);
  padding: 24px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.05), 0 16px 24px 2px rgba(0, 0, 0, 0.03),
    0 6px 30px 5px rgba(0, 0, 0, 0.03);
  color: #1f8cf6;
  cursor: pointer;
  transform: translateX(-50%);

  .message {
    display: block;
    overflow: hidden;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .close {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    border: 0;
    border-radius: 50%;
    background: transparent;
    cursor: pointer;

    img {
      width: 16px;
      height: 16px;
    }
  }
}

.buy-service-tips-enter-active,
.buy-service-tips-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.buy-service-tips-enter-from,
.buy-service-tips-leave-to {
  opacity: 0;
  transform: translate(-50%, -8px);
}
</style>
